<template>
  <div>
    <div>
      <span class="fs14">颜色设置</span>
      <color-picker
        class="mt8"
        v-for="(colorList, index) in gaugeColorList"
        :key="index"
        :color.sync="colorList.color"
      />
    </div>
    <slider-and-input class="mt16" :value.sync="axisLineWidth" title="宽度设置" :sliderMax="100" suffix="px" />
    <div class="mt8">
      <span class="fs14">占比设置</span>
      <slider-and-input
        class="mt8"
        v-for="(gaugeRadius, index) in gaugeRadiusList"
        :value.sync="gaugeRadius.radius"
        title=""
        :key="index"
        :sliderMax="150"
        suffix="%"
      />
    </div>
  </div>
</template>

<script>
import publicData from "../publicData"
export default {
  mixins: [publicData],

  props: {
    seriesData: {
      type: Array
    },
    ids: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      gaugeColorList: [],
      gaugeRadiusList: [],
      collapse: {} // 用来存放当前数据组和图例设置里面的展开收起状态
    }
  },
  created() {
    this.init()
  },
  watch: {
    ids: {
      deep: true,
      handler(val, oloVal) {
        this.init()
      }
    },
    gaugeColorList: {
      deep: true,
      handler(val, oldVal) {
        if (val.length == 0) return
        val.forEach(item => {
          this.$changeOptionsEV(item.color, "chartOption.series." + item.index + ".axisLine.lineStyle.color.0.1", false)
        })
      }
    },
    gaugeRadiusList: {
      deep: true,
      handler(val, oldVal) {
        if (val.length == 0) return
        val.forEach(item => {
          this.$changeOptionsEV(item.radius + "%", "chartOption.series." + item.index + ".radius", false)
        })
      }
    }
  },
  computed: {
    getOptions: {
      get() {
        return this.$getOptions()
      }
    },
    axisLineWidth: {
      get() {
        return this.seriesData[1].axisLine.lineStyle.width
      },
      set(newVal) {
        this.seriesData.forEach((data, index) => {
          if (data.type === "gauge") {
            this.$changeOptionsEV(parseInt(newVal), "chartOption.series." + index + ".axisLine.lineStyle.width", false)
          }
        })
      }
    }
  },
  methods: {
    init() {
      this.initGaugeColorList()
      this.initGaugeRadiusList()
    },
    // 初始化饼图后面axisLine的颜色
    initGaugeColorList() {
      let result = []
      // 刻度线的颜色只允许设置为纯色
      this.seriesData.forEach((item, index) => {
        // 纯色
        if (item.type === "gauge") {
          result.push({
            color: item.axisLine.lineStyle.color[0][1],
            index: index
          })
        }
      })
      this.gaugeColorList = result
    },
    // 初始化饼图后面刻度线的半径
    initGaugeRadiusList() {
      let result = []
      // 刻度线的颜色只允许设置为纯色
      this.seriesData.forEach((item, index) => {
        // 纯色
        if (item.type === "gauge") {
          result.push({
            radius: parseInt(item.radius),
            index: index
          })
        }
      })
      this.gaugeRadiusList = result
    },
    collapsibleItemClickHandle($event, index) {
      this.collapse[$event.type].isActive = $event.isActiveCopy
      const _index = this.collapseDataActiveNames.findIndex(it => it === index)
      _index === -1 ? this.collapseDataActiveNames.push(index + "") : ""
    }
  }
}
</script>

<style scoped>
.width_100 {
  width: 100%;
}
.custom-color {
  display: inline-block;
  width: calc(100% - 72px);
  vertical-align: middle;
}
.pie-options-setting-dialog .tabs-color {
  width: 86px;
  height: 24px;
}
.pie-options-setting-dialog .tabs-color .tabs-color-item {
  padding: 0 8px;
  background: #35383f;
  border-radius: 3px;
  position: static;
  width: 42px;
  height: 22px;
  font-size: 13px;
  line-height: 18px;
  color: #717989;
  cursor: pointer;
}
.pie-options-setting-dialog .tabs-color .tabs-color-item.active {
  background: var(--themeColor);
  color: #ffffff;
}
.percent65_ {
  width: calc(100% - 65px);
}
</style>
